import React, { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/teams-app-internal-analytics/use-analytics-events';

import { firedAt, type CardErrorType } from '../../analytics';
import { CardError } from './CardError';

/**
 * Renders the error state and fires `ui.profilecard.rendered.error` once
 * per distinct `errorType`. `hasRetry` is always `false` today.
 */
export function CardErrorState({
	testId,
	errorType,
}: {
	testId: string;
	errorType: CardErrorType;
}): React.JSX.Element {
	const { fireEvent } = useAnalyticsEvents();
	useEffect(() => {
		fireEvent('ui.profilecard.rendered.error', {
			firedAt: firedAt(),
			errorType,
			hasRetry: false,
		});
	}, [fireEvent, errorType]);
	return <CardError testId={testId} />;
}
